export default defineNuxtRouteMiddleware(() => {
  if (String(useRuntimeConfig().public.purchaseWebhooksEnabled) !== 'true') {
    return abortNavigation(createError({ statusCode: 404, statusMessage: 'Page not found' }))
  }
})
